import React from "react";
import {
  GeneralStyle,
  ContentHeader,
  ContentTitle,
  ContentForm,
  SelectField,
  TextField,
} from "./CreatePolicyComponent.styled";
import { Divider } from "@mui/material";
import { Form, CloseButton } from "react-bootstrap";
import Select from "react-select";
import { theme as themeConfig } from "../../themes/themes";
import SaveIcon from "@mui/icons-material/Save";

const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: themeConfig.primary.icon,
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: themeConfig.primary.blue,
      boxShadow: "0 0 0 0.2rem rgb(0 123 255 / 25%)",
    },
  }),
};

const CreatePolicyComponent = ({
  title,
  textFieldLabel,
  selectFieldLabel,
  textValue,
  selectedOptions,
  options,
  handleTextFieldChange,
  handleSelectChange,
  handleSave,
  showCreate,
  action,
}) => {
  return (
    <GeneralStyle>
      <ContentHeader>
        <ContentTitle>
          <label className="title">
            {action === "edit" ? "Update " : "Create "}
            {title}
          </label>
          <Divider orientation="vertical" />
          <label className="mandatory-info">* Mandatory Fields</label>
          <CloseButton onClick={() => showCreate("")}></CloseButton>
        </ContentTitle>
      </ContentHeader>
      <ContentForm>
        <TextField>
          <Form.Label>*{textFieldLabel}</Form.Label>
          <Form.Control
            type="text"
            placeholder={"Type here"}
            value={textValue}
            defaultValue={textValue}
            onChange={(e) => handleTextFieldChange(e)}
          />
        </TextField>
        {selectedOptions && (
          <SelectField>
            <Form.Label>*{selectFieldLabel}</Form.Label>
            <Select
              styles={customStyles}
              placeholder={"Select one or several"}
              options={options}
              defaultValue={selectedOptions}
              value={selectedOptions}
              isMulti
              onChange={(e) => handleSelectChange(e)}
            />
          </SelectField>
        )}
        <SaveIcon className="save-icon" onClick={handleSave} />
      </ContentForm>
    </GeneralStyle>
  );
};

export default CreatePolicyComponent;
